import { PropsWithChildren, ReactNode } from "react";

export function TabButtonsContainer(props: PropsWithChildren<ReactNode>) {
    return (
        <div className="z-0 flex">{props.children}</div>
    );
}

export default TabButtonsContainer;